import { useState } from "react";
import { Link } from "react-router-dom";
import { format, parseISO } from "date-fns";
import { ChevronDown, CalendarDays } from "lucide-react";
import { COLORS } from "@/lib/api";
import { CheckCircle } from "@/components/shared";
import { ProgressRing } from "@/components/todo/ListIcon";

const SHOWN = 3;
const byDue = (a, b) => (a.due_date || "9999").localeCompare(b.due_date || "9999");

const FolderRow = ({ list, open, onToggle, onTick }) => {
  const color = COLORS[list.color] || COLORS.terracotta;
  const tasks = list.items.filter((i) => !i.done).sort(byDue);
  const more = tasks.length - SHOWN;
  return (
    <li className="py-1" data-testid={`dash-folder-${list.id}`}>
      <button type="button" onClick={onToggle} aria-expanded={open} data-testid={`dash-folder-toggle-${list.id}`}
        className="w-full flex items-center gap-3 py-2.5 px-2 -mx-2 rounded-xl hover:bg-t-surface/70 transition-colors text-left">
        <ProgressRing list={list} testId={`dash-folder-ring-${list.id}`} />
        <span className="flex-1 min-w-0 font-medium truncate">{list.name}</span>
        <span className="text-xs text-t-muted whitespace-nowrap" data-testid={`dash-folder-count-${list.id}`}>{tasks.length} to do</span>
        <ChevronDown className={`h-4 w-4 text-t-muted transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul className="ml-[3.25rem] mt-1 mb-2 space-y-1 fade-up" data-testid={`dash-folder-tasks-${list.id}`}>
          {tasks.slice(0, SHOWN).map((t) => (
            <li key={t.id} className="flex items-center gap-3 py-1.5" data-testid={`dash-task-${t.id}`}>
              <CheckCircle checked={false} onClick={() => onTick({ ...t, list })} color={color} testId={`dash-task-check-${t.id}`} />
              <span className="flex-1 text-sm">{t.text}</span>
              {t.due_date && <span className="text-xs text-t-muted flex items-center gap-1"><CalendarDays className="h-3 w-3" />{format(parseISO(t.due_date), "MMM d")}</span>}
            </li>
          ))}
          {more > 0 && (
            <li><Link to={`/todos?list=${list.id}`} data-testid={`dash-folder-more-${list.id}`} className="text-xs font-medium text-t-primary hover:text-t-primary-hover">+{more} more</Link></li>
          )}
        </ul>
      )}
    </li>
  );
};

export const UpNextFolders = ({ lists, onTick }) => {
  const [open, setOpen] = useState({});
  const folders = lists.filter((l) => l.items.some((i) => !i.done));
  if (!folders.length) return <p className="text-sm text-t-faint py-4" data-testid="dash-folders-empty">All caught up. Enjoy the calm.</p>;
  return (
    <ul className="divide-y divide-t-surface" data-testid="dash-folders">
      {folders.map((l) => (
        <FolderRow key={l.id} list={l} open={!!open[l.id]} onToggle={() => setOpen((o) => ({ ...o, [l.id]: !o[l.id] }))} onTick={onTick} />
      ))}
    </ul>
  );
};
